<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/11Pux8p/tc-custom/9781250752109.jpg?1742451304093" alt="This image is the cover for the book Ghosts of Sherwood"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Ghosts of Sherwood
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Carrie Vaughn's <i>The Ghosts of Sherwood</i> revisits the Robin Hood legend with a story of the famed archer's children.</b><br/><br/><i>Everything about Father is stories.</i><br/><br/> Robin of Locksley and his one true love, Marian, are married. It has been close on two decades since they beat the Sheriff of Nottingham with the help of a diverse band of talented friends. King John is now on the throne, and Robin has sworn fealty in order to further protect not just <i>his</i> family, but those of the lords and barons who look up to him – and, by extension, the villagers they protect.<br/><br/> There is a truce. An uneasy one, to be sure, but a truce, nonetheless.<br/><br/> But when the Locksley children are stolen away by persons unknown, Robin and Marian are going to need the help of everyone they’ve ever known, perhaps even the ghosts that are said to reside deep within Sherwood.<br/><br/> And the Locksley children, despite appearances to the contrary, are not without tricks of their own… </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Carrie Vaughn
      </h2>
      
      <p class="authorDescription body article"> Carrie Vaughn is the <I>New York Times</I>&ndash;bestselling author of more than twenty novels and over eighty short stories. She&#39;s best known for the Kitty Norville urban fantasy series about a werewolf who hosts a talk radio advice show for supernatural beings. She&#39;s also a contributor to the <I>Wild Cards</I> series of shared-world novels edited by George R.R. Martin. She has been nominated for various awards, including the Hugo and RT Reviewer Choice Awards. </p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Tor.com
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?72c7b8b8